export default {
  CommonCancel: 'Annuler',
  CommonSave: 'Enregistrer',
  Next: 'Suivant',
  CommonYes: 'Oui',
  CommonNo: 'Non',
  CommonDelete: 'Supprimer',
  User: 'Utilisateur',
  Users: 'Utilisateurs',
  LoginButton: "Je m'identifie",
  LogoutButton: 'Déconnexion',
  LoginMessageTitle: 'Bienvenue sur ORFI',
  LoginMessageBody: "Votre authentification à la solution de recueil des faits d'incivilités évolue.",
  LoginSupport: 'Support connexion utilisateurs',
  LoginEmailInputPlaceholder: 'Identifiant',
  LoginPasswordInputPlaceholder: 'Mot de passe',
  InvalidLoginCredentials: 'Les identifiants sont invalides',
  InvalidEmptyInputLogin: 'Veuillez renseigner tous les champs',
  LoginPasswordForgotten: 'Mot de passe oublié',

  HomeScreenTitleReport: 'Signaler',
  HomeScreenDescriptionReport: 'Rapportez toutes dégradations ou incivilités',
  HomeScreenTitleSearch: 'Consulter',
  HomeScreenDescriptionSearch: "Accédez à l'ensemble de vos signalements",
  HomeScreenTitleStats: 'Statistiques',
  HomeScreenDescriptionStats: 'Visualisez un ensemble de données',
  HomeScreenTitleHelp: 'Aide',
  HomeScreenDescriptionHelp: 'Trouvez des réponses à vos questions',
  HomeScreenTitleConfiguration: 'Configuration',
  HomeScreenDescriptionConfiguration: "Administrez les données de l'application",
  HomeScreenTitleOrganismes: 'Administration',
  HomeScreenDescriptionOrganismes: 'Administrez les données de votre organisme',

  ConsultTitle: 'Liste des événements',
  MapConsultTitle: 'Carte des événements',
  SelectAll: 'Sélectionner tout',
  SelectOneOption: 'Sélectionner une option',
  MarkAsRead: 'Marquer comme lu',
  ValidateEventsTooltip: 'Valider tous les signalements sélectionnés',

  ReportTitle: 'Signaler un événement',
  ReportEditTitle: "Modifier le signalement d'un événement",
  ReportViewTitle: 'Évènement',
  ReportGeneralInformationTitle: 'INFORMATIONS GÉNÉRALES',
  ReportGeneralInformationDateTitle: "Date de l'événement",
  ReportGeneralInformationHour: 'Tranche horaire',
  ReportGeneralInformationServiceTitle: 'Service',
  ReportGeneralInformationAgentTitle: 'Agent',
  ReportGeneralInformationServicePlaceholder: 'SERVICE ASSOCIÉ',
  ReportGeneralInformationAgentPlaceholder: 'AGENT ASSOCIÉ',
  ReportComplementaryInformationTitle: 'INFORMATION COMPLÉMENTAIRE',
  ReportTypeTitle: "TYPE D'ÉVÉNEMENT",
  ReportSubTypeTitle: 'SOUS-TYPE',
  ReportCategoryTitle: 'CATÉGORIE',
  ReportPlaceTitle: 'TYPE DE LIEU',
  ReportInputSite: 'Site',
  ReportInputBuilding: 'Bâtiment',
  ReportInputFloor: 'Étage',
  ReportSubPlaceTitle: 'SOUS-TYPE DE LIEU',
  ReportLocationTitle: "LIEU DE L'ÉVÉNEMENT",
  ReportInputComment: "Commentaire sur l'événement",
  ReportInputCommentDescription:
    "Ces commentaires décrivent l'événement constaté et les moyens envisagés pour réparer un dommage. Ils ne doivent jamais permettre l'identification d'une personne, en respect de la réglementation RGPD en vigueur.",
  ReportRecurrentFact: 'Fait récurrent ou permanent',
  ReportRecurrentFactDescription: "Fait qui s'étend sur plusieurs jours",
  ReportCamera: 'Espace avec vidéosurveillance',
  ReportInputLocationTypeholderSite: 'Saisir un site',
  ReportInputLocationTypeholderBuilding: 'Saisir un bâtiment',
  ReportInputLocationTypeholderFloor: 'Saisir un étage',
  SiteCriteria: 'Sites',
  EventSite: 'Site',
  ReportCameraDescription: "L'espace dispose de caméras de surveillance",
  ReportInputCommentPlaceholder: 'Saisir un commentaire',
  ReportSubmitError: 'Veuillez renseigner tous les champs obligatoires',
  ReportInputAddress: 'Saisir une adresse',
  FiltersTitle: 'Filtres',
  GroupCriteria: 'Groupes',
  GroupCodeCriteria: 'Code union',
  GroupNameCriteria: 'Nom',
  GroupCommentAndAttachmentsCriteria: 'Commentaires et pièces jointes',
  EnabledCommentAndAttachmentsCriteria: 'Commentaires et pièces jointes activés',
  TypeCriteria: 'Types',
  StatusCriteria: 'Statuts',
  CityCriteria: 'Commune',
  AuthorCriteria: 'Déclarant',
  PatrimonyCriteria: 'Patrimoine',
  SectorCriteria: 'Secteur',
  AgencyCriteria: 'Agence',
  AllegedPerpetratorCriteria: 'Auteur présumé',
  RecurringCriteria: 'Récurrent',
  DateCriteria: 'Dates',
  StartDate: 'Du',
  EndDate: 'Au',

  StatusNew: 'Nouveau',
  StatusProcessing: 'En cours',
  StatusValidated: 'Validé',
  StatusRefused: 'Rejeté',

  EventVictim: 'Victime',
  EventAllegedPerpetrator: 'Auteur présumé',

  EventType: 'Type',
  EventDate: 'Date',
  EventAuthor: 'Déclarant',
  EventAddress: 'Adresse',
  EventPlace: 'Lieu',
  EventCreation: 'Créé le ',
  EventBy: 'par ',
  EventCommentTitle: 'Commentaire sur le suivi',
  EventComment: 'Indiquer votre texte ici',
  EventId: "Numéro d'incident",

  NoResult: 'Aucun résultat ne correspond à la recherche.',

  LifecycleTitle: 'Cycle de vie',
  AddFollowUp: 'Ajouter un suivi',
  ActionsSummary: 'Récapitulatif des actions sélectionnées',
  NewActions: 'Nouvelle(s) action(s)',
  ValidateDefinitely: 'Valider définitivement',
  ValidateConfirmTitle: 'Confirmation de validation',
  ValidateConfirmMessage: "Une fois la FI validée il n'est plus possible de lui apporter des modifications, confirmez-vous ce choix ?",
  RejectFI: 'Rejeter',
  RejectConfirmTitle: 'Confirmation de rejet',
  RejectConfirmMessage: "Une fois la FI rejetée il n'est plus possible de lui apporter des modifications, confirmez-vous ce choix ?",
  CommentHistory: 'Commentaires',
  AddComment: 'Ajouter un commentaire',
  CommentPlaceholder: 'Saisir votre commentaire ici...',
  NoComments: 'Aucun commentaire pour le moment',
  SaveButton: 'Enregistrer',
  Complaint: 'Plainte',
  Actions: 'Actions',
  Procedure: 'Procédure',
  ITT: 'ITT en nombre de jours',
  ArretTravail: 'Arrêt de travail en nombre de jours',
  Prejudice: 'Préjudice estimé en €',

  DeleteConfirmTitle: 'Suppression',
  DeleteConfirmText: 'Etes-vous sûr de vouloir supprimer ce libellé ?',
  DeleteConfirmTextWithType: 'Etes-vous sûr de vouloir supprimer ce ',
  DeleteConfirmTitleWithType: 'Suppression de ',
  DeleteConfirmCancel: 'Annuler',
  DeleteConfirmOk: 'Confirmer',
  ExportConfirmSelected: 'Exporter la sélection',
  ExportConfirmAll: 'Exporter toutes les pages',
  ExportProgress: 'Export en cours, veuillez patienter...',
  ExportDownloading: 'Finalisation et téléchargement en cours, ne fermez pas cette fenêtre...',
  ErrorDelete:
    "La suppression est impossible, des signalements sont associés à cet élément. Vous pouvez cependant le désactiver s'il s'agit d'une agence.",
  ErrorImport: "Une erreur est survenue lors de l'import",
  ErrorExport: "Une erreur est survenue lors de l'export",
  ErrorSync: 'Pas de données pour ce groupe dans le LDAP',
  SuccessImport: 'Import terminé',
  SuccessImportDryRun: 'Import à blanc terminé',
  PendingImport: 'Import des données en cours',
  ImportInProgress: 'Import en cours...',
  SuccessExport: 'Export terminé',
  SuccessSync: 'Synchronisation avec le LDAP terminé',
  SuccessSyncCRM: 'Synchronisation avec le CRM terminé',
  WarningSyncCRM: "Utilisateurs n'ont pas été synchronisés avec le CRM",
  ErrorSyncCRM: 'Une erreur est survenue lors de la synchronisation avec le CRM',
  EditConfirmTitle: "Edition d'un libellé",
  EditConfirmTitleWithYpe: 'Edition de ',
  ModalConfirmCancel: 'Annuler',
  ModalConfirmOk: 'Confirmer',
  ModalConfirmDryRun: 'Importer à blanc',
  CreateConfirmTitle: "Création d'un libellé",
  CreateConfirmTitleWithType: 'Création de ',

  StatsTitle: 'Statistiques',
  StatsDashboardTitle: 'Mon tableau de bord',
  StatsDashboardSubTitle: "Accédez aux graphiques prédéfinis permettant de piloter l'activité",
  StatsMapTitle: 'Carte',
  StatsMapSubTitle: "Visualisez l'ensemble des signalements sur une carte",
  StatsDataTitle: 'Data',
  StatsDataSubTitle: "Accédez à l'outil Tableau et exploitez les données de votre organisme",

  ConfigurationTitle: 'Configuration des libellés',
  ConfigurationCategory: 'Catégories',
  ConfigurationPlace: 'Sous-lieux',
  ConfigurationProcess: 'Procédures',
  ConfigurationComplaint: 'Plaintes',
  ConfigurationGroup: 'Organismes',
  ConfigurationGroupTitle: 'Configuration des organismes',
  ConfigurationReconnection: 'Un rechargement de la page est nécessaire pour que les changements prennent effet',

  DashboardTitle: 'Tableau de bord',
  DashboardProcess: 'procédures',
  DashboardComplaint: 'plaintes',
  For: 'pour',
  Event: 'événements',
  DashboardPrejudice: 'de dégats estimés',
  DashboardEventDate: 'créés par jour',
  DashboardType: 'Type',
  DashboardSubtitle: "d'événements",
  DashboardVideo: 'Espaces surveillés',
  DashboardPie: 'Proportion',
  DashboardPieChart: 'Diagramme',
  DashboardBarChart: 'Histogramme',
  KeyNumbers: 'Chiffres clés',
  ByYear: 'par an',
  Cumbersome: "dépôts d'encombrants",
  Aggression: 'agressions',
  Degradation: 'dégradations de biens',

  StatusTitle: 'Statut',
  EventSubtitle: 'des événements',

  Yes: 'Oui',
  No: 'Non',

  ValidationEventsTitle: 'Valider tous les signalements sélectionnés',
  ErrorValidationEventsDescription: 'Un signalement est au statut "validé" ou "rejeté". Vous ne pouvez pas valider.',
  ValidationEventsDescription: 'Êtes-vous sûr de valider ?',

  ExportEvent: "Export d'événements",
  NoEventSelectedExport: 'Veuillez sélectionner au moins un événement',
  ExportTooMuchEvents: "Vous pouvez extraire jusqu'à 100 fiches. Activez les filtres.",
  ExportTitle: 'Fiche de signalement des incidents',
  ExportGroups: 'Bailleurs',
  ExportGroup: 'Bailleur',
  ExportAddress: 'Adresse',
  ExportAuthorRole: 'Fonction du déclarant',
  ExportContext: "Contexte de l'incident",
  ExportDate: "Date de l'incident",
  ExportHour: 'Heure',
  ExportLocation: "Lieu de l'incident",
  ExportCamera: 'Présence de caméras',
  ExportCommentOnEvent: "Commentaire sur l'événement",
  ExportCommentOnEventDescription: "Ces données exportées sur des supports hors d'ORFI  sont de la responsabilité des bailleurs",
  ExportTypes: "Types d'incidents",
  ExportDetails: "Précisions de l'incident",
  ExportVictim: 'Victime',

  GroupTableHeaderCode: 'Code union',
  GroupTableHeaderName: 'Nom',
  GroupTableHeaderAttachments: 'Pièces jointes',
  GroupTableHeaderCommentAndAttachments: 'Commentaires et pièces jointes',
  GroupTableHeaderOldField: 'Ancien affichage patrimoine',
  GroupTableHeaderOldFieldHelpStart: "Vous avez deux possiblités en terme d'affichage lors d'un signalement pour votre organisation:",
  GroupTableHeaderOldFieldHelpOptionOne: '- Affichage des champs "Site", "Étage" et "Bâtiment" (interrupteur activé)',
  GroupTableHeaderOldFieldHelpOptionTwo: '- Affichage des champs "Patrimoine", "Secteur", "Agence" (interrupteur désactivé)',
  GroupTableHeaderOldFieldHelpOptionEnd:
    'À noter que cette option n\'est disponible qu\'un certain temps pour assurer la transition vers l\'affichage des champs "Patrimoine", "Secteur", "Agence"',
  GroupTableUnknownName: 'Nom inconnu',
  GroupTableLogin: 'Se connecter en tant que',
  ErrorGroupSync: 'Une erreur est survenue lors de la synchronisation des organismes',
  ErrorGroupFetch: 'Une erreur est survenue lors de la récupération des organismes',
  ErrorGroupUpdate: "Une erreur est survenue lors de la mise à jour de l'organisme",

  EstateLabelConfiguration: 'Configuration des libellés',
  EstateConfiguration: 'Configuration du patrimoine',
  EstateConfigurationImportCsvTitle: 'Importez votre fichier .csv',
  EstateAgencyConfiguration: 'Configuration des équipes',
  EstateMonCompteTitle: 'Mon compte',
  EstateMonCompteSubtitle: 'Créer un collaborateur, Ajouter ou Modifier des droits',
  EstateUserAgencyCriteria: 'Adresse',
  EstateUserSupervisorCriteria: 'Responsable',

  PaginationEvent: 'événement',
  PaginationEvents: 'événements',

  HelpTitle: 'Aide',
  HelpDoc: "Manuel d'utilisation",
  HelpRGPD: 'Clauses RGPD',
  HelpDirector: 'Pour toutes autres questions, contactez notre support ',
  HelpKeeper: "Pour toutes autres questions sur l'utilisation d'ORFI, contactez votre référent ORFI.",

  DuplicateToastError: "Une erreur est survenue lors de l'enregistrement et la duplication du signalement.",
  DuplicateToastSuccess: 'Le signalement {{id}} a bien été créé et dupliqué dans la nouvelle fiche.',
  SaveToastSuccess: 'Le signalement {{id}} a bien été créé.',
  SaveToastSuccessCriticalEvent: 'Ce signalement critique est envoyé aux responsables.',
  SaveToastError: "Une erreur est survenue lors de l'enregistrement du signalement.",
  EditToastSuccess: 'Le signalement {{id}} a bien été modifié.',
  EditToastError: 'Une erreur est survenue lors de la modification du signalement {{id}}.',
  UpdateEventsToastSuccess: 'Le(s) {{size}} signalement(s) est bien passé au statut : validé',
  UpdateEventsToastError: 'Une erreur est survenue lors de la modification de(s) signalement(s)',

  SwitchDirectorSuccess: 'Changement de rôle effectué',

  UserEditionFullname: 'Prénom NOM',
  UserEditionAgencies: 'Adresses',
  UserEditionSupervisors: 'Responsables',
  UserEditionProfile: 'Profil',
  allPatrimonies: 'Tous le patrimoine',
  UserEditionSearchPlaceholder: 'Rechercher des utilisateurs ...',
  PatrimonyEditionSearchPlaceholder: 'Rechercher un patrimoine ...',

  PatrimoniesImport: 'Import de patrimoines',
  AgencyImport: 'Import de lien utilisateur/adresse',
  SupervisorImport: 'Import de responsables',
  UserRelationsImport: 'Import des relations gardiens/agences/responsables',

  UserConfigurationNoagencies: 'Tout le patrimoine',
  UserConfigurationNosupervisors: 'Pas de responsable',

  Disabled: '(désactivée)',
  Label: 'Label',
  Code: 'Code',
  Required: 'Champ obligatoire',
  Retry: 'Réessayer',
  ErrorFetchLocationTypes: 'Une erreur est survenue lors de la récupération des types de lieux',
  ErrorFetchVictims: 'Une erreur est survenue lors de la récupération des victimes',
  ErrorFetchAllegedPerpetrators: 'Une erreur est survenue lors de la récupération des auteurs présumés',
  ErrorFetchCategories: 'Une erreur est survenue lors de la récupération des catégories',
  ErrorFetchTypes: "Une erreur est survenue lors de la récupération des types d'événements",
  ErrorFetchSites: 'Une erreur est survenue lors de la récupération des sites',
  ErrorFetchCities: 'Une erreur est survenue lors de la récupération des communes',
  ErrorFetchPatrimonies: 'Une erreur est survenue lors de la récupération du patrimoine',
  ErrorFetchAuthors: 'Une erreur est survenue lors de la récupération des déclarants',
  ErrorFetchGroup: "Une erreur est survenue lors de la récupération des informations de l'organisme",
  ErrorFetchEvents: 'Une erreur est survenue lors de la récupération des événements',
  ErrorLogin:
    'Une erreur de connexion est survenue, veuillez réessayer dans quelques instants ou nous contacter en cas de non résolution du problème',

  DropzonePlaceholder: 'Faites glisser un fichier ici ou %{linkStart}importez un fichier%{linkEnd}',
  DropzoneAcceptedFiles: 'Fichiers acceptés : ',
  DropzoneFileMaxSize: 'Taille maximale du fichier : %{size} Mo',
  DropzoneMimeTypeInvalid: 'Type de fichier invalide',
  DropzoneFileMaxSizeError: 'Le fichier est trop volumineux',
  DropzoneMaxFilesErrorToast: 'Nombre de fichiers maximum atteint',
  DropzoneMaxFilesErrorMessage: 'Le nombre maximum de pièces jointes autorisé est de ',
  DropzoneFileFormatError: 'Le format du fichier est incorrect',
  DropzoneFileMaxFiles: 'Nombre de fichiers maximum : $0',
  DropzoneFileMaxFilesError: 'Le nombre de fichiers est trop important',
  DropzoneSupressFile: 'Supprimer la pièce jointe',
  DropzoneSupressFileMessage: 'La suppression est définitive, êtes-vous sûr de vouloir supprimer cette pièce jointe ?',
  FileDownloadError: 'Une erreur est survenue lors du téléchargement du fichier',
  FileDeleteError: 'Une erreur est survenue lors de la suppression du fichier',
  FileDeleteSuccess: 'Le fichier a bien été supprimé',
  EventFiles: 'Pièces jointes',
  EventFilesSubtitle: 'Merci de veiller au respect des %{linkStart}règles RGPD%{linkEnd}.',
  DropzoneAnonymizeFile: 'Flouter les visages',
  DropzoneAnonymizeFileMessage: 'Souhaitez-vous effectuer un traitement de floutage ?',
  DropzoneAnonymizeFileMessageIndividual: 'Sélectionnez les images à flouter :',
  DropzoneAnonymizeFileYes: 'Flouter',
  DropzoneAnonymizeFileNo: 'Ne pas flouter',
  DropzoneNoImagesToAnonymize: 'Aucune image à flouter dans les fichiers ajoutés.',
  CommonSelectAll: 'Tout sélectionner',
  CommonDeselectAll: 'Tout désélectionner',
  CommonContinue: 'Continuer',
  AnonymizeSuccess: 'Les visages ont été floutés avec succès.',
  AnonymizeError: 'Une erreur est survenue lors du floutage des visages. Les fichiers ont été enregistrés sans floutage.',

  AllAddresses: 'Tout le patrimoine',
  Search: 'Rechercher un patrimoine...',
  NoAddressesAvailable: 'Aucun patrimoine disponible',
  NoAddressesAssociated: 'Aucun patrimoine associé',

  AssociateAddressesTo: 'Associer le patrimoine à',
  AvailableAddresses: 'Patrimoine disponible',
  AssociatedAddresses: 'Patrimoine associé',
  Close: 'Fermer',
  SuccessAssociateAddresses: 'Le patrimoine a été associé avec succès',
  ErrorAssociateAddresses: "Une erreur est survenue lors de l'association du patrimoine",

  Validate: 'Confirmer',
  Cancel: 'Annuler',

  SuccessAddressUpdate: 'Le patrimoine a été mis à jour avec succès',
  ErrorAddressUpdate: 'Une erreur est survenue lors de la mise à jour du patrimoine',

  patrimony: {
    agencyCount: '{{label}} ({{count}})',
  },

  NoDataMessage: 'Aucune donnée disponible',
  TreeViewTitle: 'Liste du patrimoine',

  NoDataFound: 'Aucune donnée trouvée',

  ErrorLoadingPatrimonies: 'Une erreur est survenue lors du chargement du patrimoine',

  TransferToAvailable: 'Transférer vers disponible',
  TransferToAssociated: 'Transférer vers associé',

  PendingSync: 'Synchronisation en cours, cela peut prendre quelques minutes, veuillez patienter...',

  DesactivationConfirmMessage: 'Êtes-vous sûrs de vouloir désactiver le/les utilisateur(s) sélectionné(s) ?',
  DesactivationTitle: 'Désactivation',
  DesactivationSuccess: 'Utilisateur désactivé avec succès',
  DesactivationError: "Erreur lors de la désactivation de l'utilisateur",
  DisabledUserMessage: 'Cet utilisateur a été désactivé',

  ImportPatrimonyTitle: 'Import de patrimoines',
  ImportTeamsTitle: 'Import des équipes',
  ImportInstructionsTitle: "Instructions pour l'import",
  ImportModulesTitle: "Modules d'imports disponibles :",
  ImportDryRunLabel: 'Import à blanc',
  ImportDryRunDescription: 'vérifie le fichier et affiche les erreurs sans créer de données',
  ImportRealLabel: 'Import réel',
  ImportRealDescription: 'crée les patrimoines, secteurs et agences à partir du fichier',
  ImportFileFormatTitle: 'Format du fichier',
  ImportFileFormatCSV: 'Fichier CSV avec séparateur point-virgule (;)',
  ImportFileFormatEncoding: 'Encodage recommandé : UTF-8',
  ImportRequiredColumnsTitle: 'Colonnes obligatoires :',
  ImportRequiredColumnPatrimony: 'Code patrimoine | Libellé patrimoine',
  ImportRequiredColumnSector: 'Code secteur | Libellé secteur',
  ImportRequiredColumnAgency: 'Code agence | Libellé agence',
  ImportOptionalColumnsTitle: 'Colonnes optionnelles :',
  ImportOptionalColumnManagerEmail: 'Email du responsable',
  ImportOptionalColumnGuardianEmail: 'Email du gardien',
  ImportSelectFileLabel: 'Sélectionner votre fichier CSV',
  ImportFileSelected: 'Fichier sélectionné :',
  ImportDryRunButton: 'Importer à blanc',

  ImportSimulationTitle: 'Import à blanc',
  ImportCompletedWithErrors: 'Import terminé avec des erreurs',
  ImportSuccessful: 'Import réussi',
  ImportDataAlreadyPresent: 'Données déjà présentes',
  ImportDataAlreadyImported: 'Simulation réussie, mais aucun changement à appliquer',
  ImportErrorReportTeams: 'rapport-erreurs-equipes.txt',
  ImportErrorReportPatrimonies: 'rapport-erreurs-patrimoines.txt',
  ImportWillBeImported: "Lignes prêtes à l'import",
  ImportLinesImported: 'Lignes importées',
  ImportLinesWithErrors: 'Lignes en erreur',
  ImportTotalProcessed: 'Lignes traitées',
  ImportPartialCompleted: 'Import partiel terminé',
  ImportPartialMessage: "%{successCount} ligne(s) ont été importées avec succès. %{errorCount} ligne(s) ont été ignorées à cause d'erreurs.",
  ImportPageWillReload: 'La page se rechargera automatiquement quand vous fermerez cette modal pour afficher les nouveaux éléments.',
  ImportCompletedSuccess: 'Import terminé avec succès !',
  ImportExistingElementsIgnored: 'Éléments déjà existants (ignorés) :',
  ImportCompleteLines: '%{count} ligne(s) complète(s) (agences déjà existantes)',
  ImportExistingPatrimonies: '%{count} patrimoine(s) déjà existant(s)',
  ImportExistingSectors: '%{count} secteur(s) déjà existant(s)',
  ImportExistingAgencies: '%{count} agence(s) déjà existante(s)',
  ImportAllDataImportedMessage:
    "Le fichier est vide ou contient uniquement des données déjà présentes. Pour activer l'import, modifiez ou complétez votre fichier.",
  ImportCanCloseModal: "Vous pouvez fermer cette modal sans procéder à l'import.",
  ImportSimulationSuccess: 'Simulation partielle',
  ImportSimulationFailure: 'Échec de la simulation',
  ImportSimulationFailureMessage:
    "Le fichier téléchargé présente des erreurs de format (séparateur incorrect, nombre de colonnes erroné, fichier non CSV, lignes non existantes). Veuillez vérifier sa conformité puis réessayer l'import.",
  ImportSimulationWillImport: "Le fichier téléchargé contient des doublons ou des lignes déjà présentes dans l'outil.",
  ImportSimulationDuplicatesIgnored: "L'importation peut continuer : seules les lignes uniques seront prises en compte, les autres seront ignorées.",
  ImportSimulationProceed: '',
  ImportSimulationNoNewData: 'Aucune nouvelle donnée à importer.',
  ImportSimulationIgnoredLines: '%{count} ligne(s) ignorée(s) (agences déjà existantes)',
  ImportErrorsDetails: 'Détail des erreurs :',
  ImportErrorsLine: 'Ligne',
  ImportErrorsError: 'Erreur',
  ImportHowToFix: 'Comment corriger ?',
  ImportDownloadDetailedReport: "Téléchargez le rapport d'erreurs détaillé",
  ImportFixErrorsInCSV: 'Corrigez les lignes en erreur dans votre fichier CSV',
  ImportRetryWithFixedFile: "Réessayez l'import avec le fichier corrigé",
  ImportDownloadErrors: 'Télécharger les erreurs',
  ImportCancel: 'Annuler',
  ImportProceed: "Procéder à l'import",
  ImportClose: 'Fermer',
  LoadingAgencies: 'Chargement des agences...',
}
